import type { LoginResponseDto } from '@sheepcount/shared';
import { useState, type FormEvent } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { SheepLogo } from '@/components/logo';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Spinner } from '@/components/ui/spinner';
import { api } from '@/lib/api';
import { useAuth } from '@/lib/auth';

export function LoginPage() {
  const { token, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  if (token) return <Navigate to="/alunos" replace />;

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await api<LoginResponseDto>('/auth/login', {
        method: 'POST',
        body: { email, senha },
      });
      login(res);
      navigate('/alunos', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Não foi possível entrar');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex min-h-dvh items-center justify-center p-6">
      <div className="w-full max-w-[380px] rounded-xl border border-border bg-surface px-8 py-9 shadow-[0_1px_3px_rgba(0,0,0,0.04)]">
        <div className="mb-7 flex flex-col items-center gap-2.5">
          <SheepLogo size={60} />
          <div className="text-[22px] font-extrabold tracking-[-0.02em]">SheepCount</div>
          <div className="text-center text-[13px] text-muted">
            Controle de presença da catequese
          </div>
        </div>
        <form className="flex flex-col gap-3.5" onSubmit={(e) => void handleSubmit(e)}>
          <div className="flex flex-col gap-1.5">
            <label htmlFor="login-email" className="text-[13px] font-medium">
              E-mail
            </label>
            <Input
              id="login-email"
              type="email"
              autoComplete="email"
              placeholder="catequista@paroquia.org"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="flex flex-col gap-1.5">
            <label htmlFor="login-senha" className="text-[13px] font-medium">
              Senha
            </label>
            <Input
              id="login-senha"
              type="password"
              autoComplete="current-password"
              placeholder="••••••••"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
            />
          </div>
          {error && (
            <div className="rounded-lg border border-danger-border bg-danger-bg px-3 py-2.5 text-[13px] font-medium text-danger">
              {error}
            </div>
          )}
          <Button type="submit" className="mt-2 py-[11px] text-sm" disabled={loading}>
            {loading ? <Spinner className="size-4 border-2 border-white/40 border-t-white" /> : 'Entrar'}
          </Button>
        </form>
      </div>
    </div>
  );
}
